
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UpdateReferralSubmissionProjectRequest,
} from '../models';
import {
    UpdateReferralSubmissionProjectRequestFromJSON,
    UpdateReferralSubmissionProjectRequestToJSON,
} from '../models';

export interface UpdateProjectRequest {
    submissionId: string;
    updateReferralSubmissionProjectRequest: UpdateReferralSubmissionProjectRequest;
}

/**
 * 
 */
export class EligibilityProjectApi extends runtime.BaseAPI {

    /**
     * Update referral eligibility project details
          */
    async updateProjectRaw(requestParameters: UpdateProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateProject().'
            );
        }

        if (requestParameters['updateReferralSubmissionProjectRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralSubmissionProjectRequest',
                'Required parameter "updateReferralSubmissionProjectRequest" was null or undefined when calling updateProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/project`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralSubmissionProjectRequestToJSON(requestParameters['updateReferralSubmissionProjectRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update referral eligibility project details
          */
    async updateProject(requestParameters: UpdateProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProjectRaw(requestParameters, initOverrides);
    }

}
